<template>
  <div class="login_container">
    <div class="login_box">
      <div v-show="showClose" style="position: absolute;left: 99%;top: -25px;" @click="onCloseBlur">
        <div class="closes"></div>
      </div>
      <div class="image_box">
        <img src="../assets/register.png" alt="" style="width: 333px;height: 501px"/>
      </div>
      <el-form label-width="0" class="login_form" :model="from" :rules="login_rules" ref="loginRef">
        <div class="header"><h3 style="margin: 0;font-family: Noto Sans S Chinese !important;">用户注册</h3></div>
        <hr style="width:40px;
            border: 1px solid #1c50a7;
            margin-block-end: 1em;
            margin-top: 8px;
            padding: 0;"/>
        <el-form-item prop="username">
          <el-input placeholder="请输入账号：*仅支持英文、数字、下划线" v-model="from.username"></el-input>
        </el-form-item>
        <el-form-item prop="password">
          <el-input placeholder="请输入密码" type="password" v-model="from.password"
          ></el-input>
        </el-form-item>
        <el-form-item prop="phone">
          <el-input autocomplete="off"
                    placeholder="请输入手机号" v-model="from.phone"
          ></el-input>
        </el-form-item>
        <el-form-item prop="validate">
          <el-input placeholder="请输入验证码" v-model="from.validate" style="width: 279.8px"
          ></el-input>
          <img style="float: right;width: 133.5px;height: 44px;font-family: Noto Sans S Chinese !important;"
               :src="qrcodeUrl" alt="验证码加载失败..."
               @click="getValicode"/>
        </el-form-item>
        <el-form-item prop="phoneValidate">
          <el-input placeholder="请输入6位验证码" v-model="from.phoneValidate" style="width: 279.8px"
          ></el-input>
          <div class="timeButton" v-show="Verification" @click="handleTimeClick">获取动态密码</div>
          <div class="timeButtonClick" v-show="!Verification">{{timers}}秒后重新获取</div>
        </el-form-item>
        <div style="color: #df2525;font-size: 15px;font-family: Noto Sans S Chinese !important;">{{messages}}</div>
        <el-form-item style="margin-bottom: 0;margin-top: -10px;">
          <div style="float: left;cursor:pointer;font-family: Noto Sans S Chinese !important;">
            <el-checkbox v-model="checked">我已阅读并同意遵守</el-checkbox>
            <span style="color: #1B4FA7;font-family: Noto Sans S Chinese !important;"
                  @click="openAgreement">《用户服务协议》</span>
          </div>
          <div style="float: right;cursor:pointer;color: #1B4FA7;font-family: Noto Sans S Chinese !important;"
               @click="toLogin">已有账号，立即登录
          </div>
        </el-form-item>
        <el-form-item class="login_button">
          <el-button type="primary" @click="submitRegisterFrom()">注册</el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
import {
  authServiceClient,
  checkPhoneRequest,
  checkUserNameRequest,
  phoneCodeRequest,
  registerRequest,
  valicodeRequest
} from '../tools/auth-api'

export default {
  name: 'Register',
  data () {
    return {
      isLogin: false,
      auth_timer: null,
      timers: 60,
      isSuccess: false,
      showClose: false,
      Verification: true,
      from: {
        username: '',
        password: '',
        validate: '',
        phoneValidate: '',
        phone: ''
      },
      login_rules: {
        username: [
          { required: true, message: '请输入用户名', trigger: 'blur' },
          { min: 3, max: 20, message: '长度在 3 到 20 个字符', trigger: 'blur' },
          { validator: this.validateName, trigger: 'blur' }
        ],
        password: [
          { required: true, message: '请输入密码', trigger: 'blur' },
          { min: 5, max: 20, message: '长度在 5 到 20 个字符', trigger: 'blur' }
        ],
        validate: [
          { required: true, message: '请输入验证码', trigger: 'blur' },
          { min: 4, max: 4, message: '请输入4位验证码', trigger: 'blur' }
        ],
        phone: [
          { required: true, message: '请输入手机号', trigger: 'blur' },
          { pattern: /^1[0-9]{10}$/, message: '请输入合法手机号/电话号', trigger: 'blur' },
          { validator: this.validatePhone, trigger: 'blur' }
        ],
        phoneValidate: [
          { validator: this.validatePhoneCode, trigger: 'blur' }
        ]
      },
      qrcodeUrl: 'data:image/gif;base64,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',
      messages: '',
      checked: false
    }
  },
  watch: {
    checked (val) {
      if (val) {
        this.messages = ''
      } else {
        this.messages = '请阅读并同意协议'
      }
    }
  },
  created () {
    this.showClose = parent.window.location.pathname !== '/register'
    this.getValicode()
  },
  methods: {
    validatePhoneCode (rule, value, callback) {
      if (!this.isLogin) {
        callback()
        return
      }
      if (value === null || value === undefined || value === '') {
        callback(new Error('请输入手机验证码'))
        return
      }
      if (value.length > 6 || value.length < 6) {
        callback(new Error('请输入6位手机验证码'))
        return
      }
      callback()
    },
    handleTimeClick () {
      this.$refs.loginRef.validate((valid) => {
        if (!valid) {
          return
        }
        const that = this
        const request = phoneCodeRequest
        request.setCode(this.from.validate)
        request.setPhone(this.from.phone)
        const CODE_KEY = 'code'
        let metadata
        if (localStorage.getItem(CODE_KEY)) {
          metadata = { [CODE_KEY]: localStorage.getItem(CODE_KEY) }
        } else {
          metadata = {}
        }
        authServiceClient.sendPhoneCode(request, metadata)
          .then(res => {
            if (res.getStatus()) {
              that.messages = ''
              that.Verification = false
              this.auth_timer = setInterval(() => {
                that.timers--
                if (that.timers <= 0) {
                  that.Verification = true
                  that.timers = 60
                  clearInterval(that.auth_timer)
                }
              }, 1000)
              return
            }
            that.getValicode()
            that.messages = '验证码错误'
            that.Verification = true
            that.timers = 60
          }).catch(err => {
            that.getValicode()
            that.messages = '手机验证码发送失败'
            that.Verification = true
            that.timers = 60
          })
      })
    },
    openAgreement () {
      window.open('/agreement')
    },
    onCloseBlur () {
      parent.window.location.reload()
    },
    validatePhone (rule, value, callback) {
      const request = checkPhoneRequest
      request.setPhone(value)
      authServiceClient.checkPhone(request, null).then(res => {
        if (res.getStatus() === 3) {
          callback()
          return
        }
        callback(new Error('手机号已注册'))
      }).catch(err => {
        callback(new Error('校验出错'))
      })
    },
    validateName (rule, value, callback) {
      if (/.*[\u4e00-\u9fa5]+.*$/.test(value)) {
        callback(new Error('用户名不能含有汉字'))
        return
      }
      if (/.*[`~!#$^&*()=|{}':;',\[\]<>/?~！#￥……&*（）——|{}【】‘；：”“'。，、？]+.*$/.test(value)) {
        callback(new Error('用户名不能包含特殊字符'))
        return
      }
      const request = checkUserNameRequest
      request.setUsername(value)
      authServiceClient.checkUserName(request, null).then(res => {
        if (res.getStatus() === 3) {
          callback()
          return
        }
        callback(new Error('用户名已注册'))
      }).catch(err => {
        callback(new Error('校验出错'))
      })
    },
    toLogin () {
      this.$router.push('/login')
    },
    getValicode () {
      const CODE_KEY = 'code'
      let metadata
      if (localStorage.getItem(CODE_KEY)) {
        metadata = { [CODE_KEY]: localStorage.getItem(CODE_KEY) }
      } else {
        metadata = {}
      }
      authServiceClient.getValicode(valicodeRequest, metadata).then(res => {
        this.qrcodeUrl = 'data:image/gif;base64,' + res.toObject().valicodeImage
      })
    },
    submitRegisterFrom () {
      const that = this
      this.isLogin = true
      this.$refs.loginRef.validate((valid) => {
        if (!valid) {
          this.isLogin = false
          return false
        }
        if (!that.checked) {
          that.messages = '请阅读并同意协议'
          this.isLogin = false
          return false
        }
        const request = registerRequest
        request.setUsername(that.from.username)
        request.setPassword(that.from.password)
        request.setValicode(that.from.validate)
        request.setPhone(that.from.phone + '')
        request.setPhonecode(that.from.phoneValidate)
        const TOKEN_KEY = 'token'
        const CODE_KEY = 'code'
        let metadata
        if (localStorage.getItem(TOKEN_KEY) && localStorage.getItem(CODE_KEY)) {
          metadata = {
            [TOKEN_KEY]: localStorage.getItem(TOKEN_KEY),
            [CODE_KEY]: localStorage.getItem(CODE_KEY)
          }
        } else if (localStorage.getItem(TOKEN_KEY) && !localStorage.getItem(CODE_KEY)) {
          metadata = {
            [TOKEN_KEY]: localStorage.getItem(TOKEN_KEY)
          }
        } else if (!localStorage.getItem(TOKEN_KEY) && localStorage.getItem(CODE_KEY)) {
          metadata = {
            [CODE_KEY]: localStorage.getItem(CODE_KEY)
          }
        } else {
          metadata = {}
        }
        authServiceClient.userRegister(request, metadata).then(res => {
          if (res.getStatus() === 0) {
            that.$message({
              center: true,
              type: 'success',
              showClose: true,
              duration: 3000,
              message: res.getMessage()
            })
            that.$router.push('/login')
            return
          }
          this.isLogin = false
          that.messages = res.getMessage()
          this.getValicode()
        }).catch(err => {
          if (err && err.code === 5) {
            this.$router.push('/register')
          }
          this.isLogin = false
        })
      })
      this.isLogin = false
    }
  }
}
</script>

<style lang="less" scoped>
  .timeButton {
    border-radius: 3px;
    cursor: pointer;
    white-space: nowrap;
    padding: 10px 20px;
    border: 0px solid #000;
    width: 94px;
    height: 24px;
    float: right;
    background-color: #efeded;
    font-size: 14px;
    font-weight: 400;
    font-family: Noto Sans S Chinese !important;
    line-height: 1.7;
    text-align: center;
    color: #333333;
  }

  .timeButtonClick {
    border-radius: 3px;
    cursor: pointer;
    white-space: nowrap;
    padding: 10px 20px;
    border: 0px solid #000;
    width: 94px;
    height: 24px;
    float: right;
    background-color: #1c50a7;
    font-size: 14px;
    font-weight: 400;
    font-family: Noto Sans S Chinese !important;
    line-height: 1.7;
    text-align: center;
    color: #ffffff;
  }

  /deep/ .el-checkbox__input.is-checked + .el-checkbox__label {
    color: #606266 !important;
  }

  .closes {
    background-image: url("../assets/closeone.png");
    background-size: 32px;
    height: 32px;
    width: 32px;
  }

  .closes:hover {
    background-image: url("../assets/closetwo.png");
  }

  /deep/ .el-input__inner {
    height: 44px !important;
    font-size: 16px;
    box-shadow: 0px 3px 5px 0px rgba(0, 0, 0, 0.05);
    border-radius: 3px;
  }

  /deep/ .el-form-item.is-error .el-input__inner, .el-form-item.is-error .el-input__inner:focus, .el-form-item.is-error .el-textarea__inner, .el-form-item.is-error .el-textarea__inner:focus {
    border-color: #fbafaf !important;
  }

  /deep/ .el-form-item__error {
    font-size: 14px;
    color: rgba(223, 37, 37, 1);
  }

  /deep/ .el-form-item {
    margin-bottom: 21px;
  }

  .login_container {
    height: 0;
    width: 0;
    background-color: #feffff;
  }

  .login_box {
    width: 615px;
    height: 501px;
    background-color: white;
    border-radius: 3px;
    position: absolute;
    left: 35%;
    box-shadow: 0 0 10px #dddddd;

    .image_box {
      position: absolute;
      transform: translate(-100%);
      border-radius: 3px;
      box-shadow: 0 0 1px #dddddd;

      img {
        width: 100%;
        height: 100%;
      }
    }

    .login_button {
      font-family: Noto Sans S Chinese !important;

      .el-button {
        font-family: Noto Sans S Chinese !important;
        position: absolute;
        width: 100%;
        background-color: #1c4fa8;
        height: 48px;
        font-size: 20px;
      }
    }

    /deep/ .el-checkbox__input.is-checked + .el-checkbox__label {
      color: #1c4fa8;
    }

    .login_form {
      .header {
        font-size: 24px;
        text-align: center;
        width: 100% !important;

        h3 {
          margin: 0;
          font-size: 24px;
          font-family: Noto Sans S Chinese !important;
          font-weight: 400;
          color: rgba(51, 51, 51, 1);
        }
      }

      width: 100%;
      position: absolute;
      padding-left: 15.448%;
      padding-right: 15.448%;
      padding-top: 15px;
      box-sizing: border-box;
    }
  }
</style>
